import PageLoader from '@/common/service/flow/page-loader';
import { buildAccountBaseService } from '@/common/service/base-paid';
import { flowTypes } from '@/common/service/page-config';
import store from '@/store/index';
import {
  ABANDON_CART_EMAIL_COOKIE_KEY,
  VIEWS,
} from '@/common/constants';
import { updatePlansCheckout } from '@/common/service/checkout-utils';
// import { noticeParentWindowCheckoutSuccess } from '@/utils/modal-utils.js';
import Flow from "@/flows/flow";
import { getPartnershipParams } from '@/views/config/partner-refer/helper/params';
import { addToCartByCategoryAndBillingCycle } from '@/common/service/flow/utils';

const loadAccountPlans = (boughtPlans) => {
    return (planList = []) => {
        let categoryPlans = boughtPlans;
         categoryPlans.forEach(plan => {
            let defaultLicense = plan.cartInfo.selected_number;
            if(!(plan.amount == 0 || plan.isFreeTrial)){
                addToCartByCategoryAndBillingCycle(planList, plan.type, plan.category, plan.billing_cycle, defaultLicense);
                // selectedPlan.isFreeTrial = plan.isFreeTrial;
            }
        });
        return planList;
    };
};

const resolveView = () => {
  return VIEWS.MINI;
}

const initShoppingCart = async () => {
    const { planMap, subscriptions, boughtPlans } = await buildAccountBaseService();
    const loader = new PageLoader(planMap);
    loader.decorate('loadAccountPlans', loadAccountPlans(boughtPlans));
    const planList = await loader.dispatch();
    return {
        boughtPlans,
        subscriptions,
        planMapFlat: planList,
    };
};

const checkOutSubmit = async (submitParams) => {
    const getters = store.getters;
    const updateForm = {
        planList: store.getters.getSelectedPlans.map(x => ({planCode: x.plan_code, quantity: x.cartInfo?.selected_number})),
        actionType: 23,
    }
    const couponData = getters.orderDataPayload.coupon;
    const partnerReferParams = getPartnershipParams();

    const extensionData = {
      ...updateForm.extensionUpdateData,
      ...partnerReferParams,
      scheduledEmailId: window.$cookie.get(ABANDON_CART_EMAIL_COOKIE_KEY),
    };
    const preview = submitParams?.preview ?? false;
    const result = await updatePlansCheckout(submitParams, updateForm.planList, updateForm.actionType, couponData, extensionData, updateForm.multiRatePlan);
    if(!preview){
        try{
            // noticeParentWindowCheckoutSuccess() // this is called already in gotoSuccessPage of checkout-mixin
            if(!window.$context?.is.modal){
                   window.location.href = '/billing?align=success';
            }
        }catch(e){
            console.log(e)
        };
    }
    return result;
};

export default {
    [flowTypes.align]: class extends Flow{
        view(){ return resolveView() }
        init(){ return initShoppingCart(...arguments) }
        beforeSubmit() { return Promise.resolve() }
        submit(submitParams) { return checkOutSubmit(submitParams)}
    }
};
